// extracted by mini-css-extract-plugin
export var cardIcon = "_82-5";
export var cardIconUnframed = "_82-9";
export var checkboxCard = "_82-0";
export var checkboxCardSelected = "_82-4";
export var disabled = "_82-2";
export var interactive = "_82-1";
export var outerBorder = "_82-3";
export var spacerMedium = "_82-8";
export var spacerSmall = "_82-7";
export var spacerXsmall = "_82-6";